import * as Sentry from "@sentry/browser";
import type {Action} from "redux";


export const captureSentryError = (
	sagaName: string,
	data: Action | "none",
	errors: unknown,
	extra?: unknown
) => {
	if (Sentry) {
		// Add all the extra context
		Sentry.withScope((scope) => {
			scope.setTag("sagaError", sagaName);
			scope.setContext("action", {
				data,
			});

			scope.setContext("extra", {
				extra: JSON.stringify(extra),
			});
			Sentry.captureException(errors, {
				extra: {
					extra: JSON.stringify(extra),
					data,
				},
			});
		});
	}
};
